<template>
    <div>
        <loader v-if="loading" />                      
        <v-data-table v-if="!loading" :headers="headers"                    
                    :items="data"
                    :disable-initial-sort="true"
                    hide-actions>
            <template v-slot:items="props">
                <tr>
                    <td class="text-xs-left">{{ props.item.CountName }}</td>
                    <td v-for="header of extraHeaders" :key="header.text">
                        <span v-if="props.item.Distributions.find(d => d.Name === header.text)">{{ props.item.Distributions.find(d => d.Name === header.text).Votes }}</span>
                        <span v-else>-</span>
                    </td>
                    <td class="text-xs-left">{{ props.item.Total }}</td>                    
                </tr>
            </template>
        </v-data-table>                 
    </div>
</template>
<script>
import Loader from '@/components/Loader.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    props: ['division', 'year'],
    components: {
        Loader
    },
    created() {
        this.initialiseData();
    },
    data() {
        return {
            data: [],
            loading: true
        }
    },
    methods: {
        initialiseData: function () {
            this.loading = true;
            const url = `Elections/DistributionOfPreferences?divisionName=${this.division}&year=${this.year}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.data = response.data;
                    this.loading = false;
                });
        }
    },
    computed: {
        headers() {            
            return [{
                    text: 'Count',
                    value: 'Count'
                },
                ...this.extraHeaders,
                {
                    text: 'Total',
                    value: 'Total'
                }
            ];
        },
        extraHeaders() {
            // add header for candidates 
            const extraHeaders = [...new Set(this
                .data
                .flatMap(d => d.Distributions)
                .map(d => d.Name))]
                .map(d => ({ text: d, value: '' }));            
            return extraHeaders;
        }
    }
}

</script>